import axios from "axios";
import config from "../config";

const apiBaseURL = (process.env.REACT_APP_API_URL ?? config.api.API_URL ?? "").replace(/\/+$/, "");

axios.defaults.baseURL = apiBaseURL;
axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;
axios.defaults.headers.common["Accept"] = "application/json";

export default axios;
